import { ContactMethod } from './types';
import { contactMethodMetaMap } from './config';
import { cn } from 'utils/style-utils';

export type ContactInfoIconProps = {
  method: ContactMethod;
  className?: string;
};

export const ContactInfoIcon = ({
  method,
  className,
}: ContactInfoIconProps) => {
  const metadata = contactMethodMetaMap[method];

  return (
    <div
      className={cn(
        'border border-neutral-300 size-8 rounded-full grid place-content-center shrink-0 group',
        className,
      )}
    >
      {metadata.icon}
    </div>
  );
};
